var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconPlus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.8C7.11046 8.8 7.2 8.88954 7.2 9L7.2 14.6C7.2 14.8209 7.37909 15 7.6 15H8.4C8.62091 15 8.8 14.8209 8.8 14.6V9C8.8 8.88954 8.88954 8.8 9 8.8H14.6C14.8209 8.8 15 8.62091 15 8.4V7.6C15 7.37909 14.8209 7.2 14.6 7.2H9C8.88954 7.2 8.8 7.11046 8.8 7V1.4C8.8 1.17909 8.62091 1 8.4 1H7.6C7.37909 1 7.2 1.17909 7.2 1.4L7.2 7C7.2 7.11046 7.11046 7.2 7 7.2H1.4C1.17909 7.2 1 7.37909 1 7.6V8.4C1 8.62091 1.17909 8.8 1.4 8.8H7Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.4ad53933949f3fb74bbb1149abe4ba60.svg";
export { ForwardRef as ReactComponent };